module.exports = __webpack_public_path__ + "img/num_bg.3ffce52f.png";